import "../../../css/bootstrap5.css";
import LinearLayout from "../../layout/LinearLayout";
import "./inputfile.css";

const FileInput = (props) => {
  return (
    <>
      <LinearLayout
        bgcolor="white"
        orientation="horizontal"
        height="match-parent"
        width="match-parent"
        className="overflow-auto"
      >
        <LinearLayout
          bgcolor="white"
          orientation="horizontal"
          height="match-parent"
          width="match-parent"
          margin={1}
          className="overflow-auto"
        >
          <input
            className={`fileinput form-control border-${props.bsize} border-${props.bcolor} bg-${props.bgcolor} text-${props.textcolor}`}
            onChange={props.handleFileChange}
            type="file"
            id="formFile"
          />
        </LinearLayout>
        <LinearLayout
          bgcolor="white"
          orientation="horizontal"
          height="match-parent"
          width="match-parent"
          margin={1}
          className="overflow-auto"
        >
          <button
            onClick={props.handleUpload}
            className={`btn btn-${props.bcolor} mb-3`}
          >
            Upload
          </button>
        </LinearLayout>
      </LinearLayout>
    </>
  );
};

export default FileInput;
//   <FileInput bsize="2" bcolor="primary" margin="2" bgcolor="white" textcolor="black"/>
// const handleUpload = async (event) => {
//   const formData = new FormData();
//   formData.append("image", event.target.files[0]);

//   try {
//     const response = await fetch(
//       "http://192.168.1.5:8080/api/products/upload-image",
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const data = await response.json();
//     console.log("Image URL:", data.url);
//   } catch (error) {
//     console.error("Upload failed:", error);
//   }
// };
{
  /* <form className="m-3 row g-3">
        <div className="col-auto">
          <input
            className={`fileinput form-control border-${props.bsize} border-${props.bcolor} m-${props.margin} bg-${props.bgcolor} text-${props.textcolor}`}
            onChange={handleUpload}
            type="file"
            id="formFile"
          />
        </div>
        <div class="col-auto">
          <button
            onClick={handleUpload}
            className={`btn btn-${props.bcolor} mb-3 m-${props.margin}`}
          >
            Upload
          </button>
        </div>
      </form> */
}
